<template>
  <SoContainer>
    <h4 class="mb-4">Tariff Summary</h4>
    <SoRow>
      <SoCol :default-width="6">
        <SoWidget v-show="tariffQuoter.showTariffSummary" filled>
          <div class="d-flex justify-space-between mb-3">
            <div ref="tq-tariff-summary">
              <h4 class="font-weight-light">Annual Cost:</h4>
              <p class="text-h2">
                {{ formatMoney({ amount: annualCost }) }} per year
              </p>
              <h4 class="mt-4 font-weight-light">Monthly Payments:</h4>
              <p class="text-h3">
                {{ formatMoney({ amount: annualCost / 12 }) }} Equal, or
              </p>
              <p class="text-h3">
                {{
                  formatMoney({
                    amount: (annualCost / 12) * SEASONAL_FACTOR_SUMMER,
                  })
                }}
                Summer,
                {{
                  formatMoney({
                    amount: (annualCost / 12) * SEASONAL_FACTOR_WINTER,
                  })
                }}
                Winter
              </p>
            </div>
            <SoCopyToClipboard :element-to-copy="el" />
          </div>
        </SoWidget>
        <SoAlert v-if="!tariffQuoter.showTariffSummary"
          >Please select a tariff for each
          {{
            tariffQuoter.quoteForMeterpoints ? "meterpoint" : "fuel"
          }}.</SoAlert
        >
      </SoCol>
    </SoRow>
  </SoContainer>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useTariffQuoter } from "@/stores/tariffQuoter"
  import { formatMoney } from "@/helpers/moneyHelpers"
  import {
    SEASONAL_FACTOR_SUMMER,
    SEASONAL_FACTOR_WINTER,
  } from "@/constants/finance"
  import SoContainer from "@/components/SoContainer.vue"
  import SoWidget from "@/components/SoWidget.vue"
  import SoAlert from "@/components/SoAlert.vue"
  import SoRow from "@/components/SoRow.vue"
  import SoCol from "@/components/SoCol.vue"
  import SoCopyToClipboard from "@/components/SoCopyToClipboard.vue"

  export default defineComponent({
    components: {
      SoWidget,
      SoAlert,
      SoContainer,
      SoRow,
      SoCol,
      SoCopyToClipboard,
    },
    data() {
      return {
        tariffQuoter: useTariffQuoter(),
        el: null as HTMLElement | null,
        formatMoney,
        SEASONAL_FACTOR_SUMMER,
        SEASONAL_FACTOR_WINTER,
      }
    },
    computed: {
      annualCost() {
        return this.tariffQuoter.getAnnualCostForSelectedBundles()
      },
    },
    mounted() {
      this.el = this.$refs["tq-tariff-summary"] as HTMLElement
    },
  })
</script>
